import {
  videoContentStopped,
  videoContentStarted,
  // Type
  VideoContentStarted,
  VideoContentStopped,
} from '@/Analytics/Segment';
import { VideoContentPayloadProps } from './SsaiTracking';

export enum VideoEventType {
  Started,
  Playing,
  Paused,
  Resumed,
  Stopped,
  Interrupted,
  SeekStarted,
  SeekCompleted,
  BufferStarted,
  BufferCompleted,
}

export interface VideoContentEventProps extends VideoContentStarted, VideoContentStopped {}

export const recordContentEvent = (
  type: VideoEventType,
  props: VideoContentEventProps,
  adPayload: VideoContentPayloadProps,
) => {
  switch (type) {
    case VideoEventType.Started: {
      videoContentStarted({
        ...(props as VideoContentStarted),
        ...adPayload,
      });
      break;
    }
    case VideoEventType.Stopped: {
      videoContentStopped({
        ...(props as VideoContentStopped),
        ...adPayload,
      });
      break;
    }
    default: {
      break;
    }
  }
};
